import {useEffect, useState} from 'react';
import {AutoComplete, Button, InputNumber, Row, Col} from 'antd';
import {getInventory} from "../../api/Api";
import {CategoryType} from "../../api/Constants";
import {fixedToDisplayUnit} from "../../util/unitutils";

export const InventorySearchWidget = ({onApiFail, refresh, onSelect, props}) => {
    const [inventory, setInventory] = useState([]);
    const [options, setOptions] = useState([])
    const [value, setValue] = useState(undefined);

    const [quantity, setQuantity] = useState(0);
    const [item, setItem] = useState(undefined);

    useEffect(() => {
        getInventory().then((x) => {
            const tableData = x.map((val, index) => {
                return {...val, key: val.id}
            });
            setInventory(tableData);
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        });
        clearForm();
    }, [refresh, onApiFail]);

    const clearForm = () => {
        setValue(undefined);
        setQuantity(0);
        setItem(undefined);
    }

    const onChange = (data) => {
        setValue(data);
    }

    const onSearch = (text) => {
        const newOptions = inventory.filter(line => {
            const ltext = text.toLowerCase();
            // console.log(`${line.name} ${line.sku}`)
            return (line.name.toLowerCase().includes(ltext) || line.sku.toLowerCase().includes(ltext));
        }).map(val => {
            const displayQuantity = fixedToDisplayUnit(val.quantity, val.unit)
            return {
                value: `${val.name} - ${val.sku},  ${displayQuantity}`,
                item: val,
                key: val.key,
            }
        });
        setOptions(newOptions)
    }

    const select = (val, option) => {
        setQuantity(0);
        setItem(option.item);
    }

    const onQuantityChange = (val) => {
        setQuantity(val);
    }

    const onOk = () => {
        if (onSelect) {
            onSelect(item, quantity);
        }
    }

    const autoCompleteStyle = {
        width: 350
    }

    const max = item ? fixedToDisplayUnit(item.quantity, item.unit) : 0;

    const okEnabled = item && (quantity > 0)

    const rowStyle = {
        marginTop: "5px",
        marginBottom: "5px"
    }

    const getDisplayQuantity = () => {
        if (item === undefined) return;
        let displayQuantity = fixedToDisplayUnit(item.quantity, item.unit).toString();
        if (item.category === CategoryType.Wholesale) {
            displayQuantity += " g"
        }
        return displayQuantity;
    }

    return <div>
        <Row style={rowStyle}>
            <Col span={8}>
                <AutoComplete placeholder={`Inventory`} style={autoCompleteStyle} options={options} onSelect={select} onSearch={onSearch} value={value} onChange={onChange} />
            </Col>
            <Col span={4}>
                <Row>
                    <Col><InputNumber placeholder={`quantity`} max={max} value={quantity} onChange={onQuantityChange}/></Col>
                </Row>
            </Col>
            <Col span={4}>
                <Button disabled={!okEnabled} onClick={onOk}>Ok</Button>
            </Col>
        </Row>
        <Row>
            { (item !== undefined) && <Col span={6} style={{color: "#108ee9"}}>
                {item.sku}
            </Col>
            }
            { (item !== undefined) && <Col span={4} style={{color: "#108ee9"}}>
                {getDisplayQuantity()} in inventory
            </Col>
            }
        </Row>
    </div>
}